import {NAME} from './constants';

export const getState = state => state[NAME];